import { render } from "./CategorySettings.vue?vue&type=template&id=5677c572"
import script from "./CategorySettings.vue?vue&type=script&lang=js"
export * from "./CategorySettings.vue?vue&type=script&lang=js"

import "./CategorySettings.vue?vue&type=style&index=0&id=5677c572&lang=css"
script.render = render

export default script